<div class="invite-friends">
  <div class="modal-header border-0">
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-content px-5 pb-5 text-center border-0">
    <ng-container *ngIf="this.showThankYou; then thankYouView; else formView"></ng-container>
    <ng-template #formView>
      <h2>{{ this.referralTitle }}</h2>
      <div class="modal-subheader mb-4" style="white-space: pre-line">
        {{ this.referralDescription }}
      </div>

      <form class="form-inline" novalidate>
        <div class="input-group">
          <input
            ngbAutofocus
            type="email"
            class="form-control"
            placeholder="Enter recipients email"
            data-cy="invite-email"
            [readonly]="this.invitePending"
            #emailInput
          />
          <span class="input-group-btn">
            <button
              class="btn btn-primary ms-2 px-4"
              [class.pending]="this.invitePending"
              type="submit"
              data-cy="invite-friends-submit"
              (click)="validateAndSubmit($event, emailInput)"
            >
              <span *ngIf="!this.invitePending">Invite</span>
              <om-logo-spinner class="spinner" *ngIf="this.invitePending" size="25"></om-logo-spinner>
            </button>
          </span>
          <div class="invalid-feedback">Please enter a valid email address.</div>
        </div>
      </form>

      <om-separator text="or"></om-separator>

      <div class="d-flex justify-content-center">
        <button
          class="btn btn-primary px-4"
          [class.copying]="isPrimeCopying"
          (click)="copyLink()"
          (keydown.enter)="copyLink()"
          (keydown.space)="copyLink()"
          >{{ primeButtonText }}</button
        >
      </div>
    </ng-template>

    <ng-template #thankYouView>
      <om-svg-phone-in-green-circle></om-svg-phone-in-green-circle>
      <h1>Invite sent!</h1>
      <div class="modal-subheader mb-4">Thanks for sharing One Medical.</div>
      <div><button class="btn btn-outline-primary btn-lg" (click)="inviteMore()">Invite More Friends</button></div>
    </ng-template>
  </div>
</div>
